import * as prismicApi from '../api/prismic';
import { showErrorPopup } from './notification-actions';

export const PRISMIC_FETCH = 'PRISMIC_FETCH';
export const PRISMIC_FETCH_SUCCESS = 'PRISMIC_FETCH_SUCCESS';

export const getPrismicDoc = (uid, type) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: PRISMIC_FETCH, payload: { uid } });
    try {
        const res = await prismicApi.getPrismicDoc(mainApi, uid, type);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: `Error fetching prismic data (${uid}/${type})!`,
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: PRISMIC_FETCH_SUCCESS,
                payload: {
                    uid,
                    data: res.data,
                },
            });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: `Error fetching prismic data (${uid}/${type})!`,
            error,
        }));
    }
};

export const getPrismicDocNoPopup = (uid, type) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: PRISMIC_FETCH, payload: { uid } });
    try {
        const res = await prismicApi.getPrismicDoc(mainApi, uid, type);
        if (!res.data.error) {
            dispatch({
                type: PRISMIC_FETCH_SUCCESS,
                payload: {
                    uid,
                    data: res.data,
                },
            });
        }
    } catch {
        // Intentionally swallowed: dashboard prismic content is non-critical and must not surface an error popup.
    }
};
